import {createSlice} from '@reduxjs/toolkit'

export const loadingSlice = createSlice({
  name: 'loading',
  initialState: {
    isLoading: false,
    loadingCount: 0,
  },
  reducers: {
    startLoadding: (state) => {
      return {
        ...state,
        isLoading: state.loadingCount === 0 ? true : state.isLoading,
        loadingCount: state.loadingCount + 1,
      }
    },
    stopLoading: (state) => {
      const newCount = Math.max(0, state.loadingCount - 1);

      return {
        ...state,
        loadingCount: newCount,
        isLoading: newCount > 0,
      }
    },
  },
})

export const isLoading = (state: any) => state.loading.isLoading

export const {startLoadding, stopLoading} = loadingSlice.actions

export default loadingSlice.reducer
